import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-onboarding',
  standalone: true,
  imports: [ButtonModule, CommonModule,TranslateModule],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent {
  currentIndex = 0;
  type = "strategy"
  items = [
    "strategy",
    "indicator",
    "goal",
    "project",
  ];
  next() {
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    this.type = this.items[this.currentIndex];
  }
  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.items.length) % this.items.length;
    this.type = this.items[this.currentIndex];
  }
}
